import Axios from "axios";

export default function getExamType(entrance_id){
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'getExamType',
            entrance_id
        }
    });
    return response;
}